import React from 'react';
import pt from 'prop-types';

import LoadingSpinner from '../../common/LoadingSpinner/LoadingSpinner';


const TableRows = ({ 
  statsData: {
    isLoading,
    data,
  },
}) => {
  if (isLoading) {
    return (
      <div className="stats-view--table--laoder">
        <LoadingSpinner
          text="Načítám statistiky"
          textSize={1}
          spinnerSize={20}
          spinnerFat={4}
        />
      </div>
    );
  }
  
  return (
    <div className="stats-view--table--data">
      { data.map((item, index) => (
        <div key={index} className={'stats-view--table--row stats-view--table--row--' + (index % 2 === 0 ? 'even' : 'odd')}>
          <div className="stats-view--table--header-sm">Id:</div>
          <div className="stats-view--table--item stats-view--table--id">{item.service_id}</div>
          <div className="stats-view--table--header-sm">Název:</div>
          <div className="stats-view--table--item stats-view--table--name">{item.web_order_name}</div>
          <div className="stats-view--table--header-sm">Přepážky:</div>
          <div className="stats-view--table--item stats-view--table--desk">{item.open_desks}</div>
          <div className="stats-view--table--header-sm">Odbavených:</div>
          <div className="stats-view--table--item stats-view--table--clients">{item.served_clients}</div>
          <div className="stats-view--table--header-sm">Maximální doba čekání:</div>
          <div className="stats-view--table--item stats-view--table--max-len">{Math.round((item.waiting_max_length / 60)) + ' min'}</div>
          <div className="stats-view--table--header-sm">Čekajících klientů:</div>
          <div className="stats-view--table--item stats-view--table--wait-cli">{item.waiting_clients}</div>
          <div className="stats-view--table--header-sm">Průměrná doba čekání:</div>
          <div className="stats-view--table--item stats-view--table--wait-avg">{Math.round((item.waiting_avg_length / 60)) + ' min'}</div>
          <div className="stats-view--table--header-sm">Poslední vyvolaný:</div>
          <div className="stats-view--table--item stats-view--table--last">{item.last_number === null || item.last_number === 0 ? '-' : item.last_number}</div>
        </div>
      ))}
    </div>
  );
};


TableRows.propTypes = {
  statsData: pt.shape({
    isLoading: pt.bool.isRequired,
    data: pt.arrayOf(pt.shape({
      service_id: pt.number.isRequired,
      web_order_name: pt.string,
      open_desks: pt.number,
      served_clients: pt.number,
      waiting_max_length: pt.number,
      waiting_clients: pt.number,
      waiting_avg_length: pt.number,
      last_number: pt.number,
    })).isRequired,
  }).isRequired,
};


export default TableRows;
